import { memo, ReactElement } from "react"
import styled from "styled-components"
import { useAppSelector } from "reducers/store"
import { useQueryState } from "context/queryState"
import ApiMetrics from "api/ApiMetrics"
import { CARDS_FETCH } from "reducers/metrics/metrics-types"
import MetricsCardItem from "./MetricsCardItem"
import IconBalanceCard from "components/EvtKit/icons/IconBalanceCard"
import IconConsumptionCard from "components/EvtKit/icons/IconConsumptionCard"
import IconEventsCard from "components/EvtKit/icons/IconEventsCard"

const Cards = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  flex-direction: column;
`

const MetricsCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 4px;
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: white;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.palette.gray_light};
    border-radius: 10px;
    cursor: pointer;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.palette.gray_medium};
  }
`

interface MetricsCardsProps {
  filters: App.MetricsParams
}

const MetricsCards = (props: MetricsCardsProps): ReactElement => {
  const { filters } = props

  const searchFilters = {
    dateStart: filters.dateStart,
    dateEnd: filters.dateEnd,
    productPrefixUrl: filters.productPrefixUrl
  }

  useQueryState(
    [CARDS_FETCH, searchFilters],
    async () =>
      new ApiMetrics().searchMetricsCards({
        ...filters
      }),
    CARDS_FETCH
  )

  const { data } = useAppSelector((state) => state.metrics.cards)

  const { netBalance, averageConsumption, totalEvents } = data

  return (
    <Cards>
      <MetricsCardContainer>
        <MetricsCardItem
          icon={<IconBalanceCard />}
          value={netBalance.result}
          description="Receita gerada no período"
          tooltipText="Receita total gerada no período"
          isPrice
        />
        <MetricsCardItem
          icon={<IconConsumptionCard />}
          value={averageConsumption.result}
          description="Faturamento médio por conta"
          tooltipText="Valor médio pago por conta no período"
          isPrice
        />
        <MetricsCardItem
          icon={<IconEventsCard />}
          value={totalEvents.result}
          description="Eventos totais gerados"
          tooltipText="Total de eventos gerados no período"
        />
      </MetricsCardContainer>
    </Cards>
  )
}

export default memo(MetricsCards)
